import { API } from 'aws-amplify';

import {
	FETCH_AL_SMELTER_PRODUCTION,
	FETCH_AL_SMELTER_PRODUCTION_ERR,
	RESET_AL_SMELTER_PRODUCTION,
	FETCH_AL_MTD_PRODUCTION,
	FETCH_AL_MTD_PRODUCTION_ERR,
	FETCH_AL_PRODUCTION_BY_SMELTER,
	FETCH_AL_PRODUCTION_BY_SMELTER_ERR,
	RESET_AL_PRODUCTION_BY_SMELTER,
	SELECT_AL_PROD_SMELTER,
	UNSELECT_AL_PROD_SMELTER,
	RESET_AL_PROD_SMELTERS
} from '../';
import config from '../../config';
import { replacer } from '../../utils';

export const fetchAlSmelterProduction =
	({
		grouping,
		id = '',
		collapse,
		ute = '',
		capAdd = '',
		startDate = '',
		endDate = ''
	}) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.alSmelterProduction, {
				grouping,
				id,
				collapse,
				ute,
				capAdd,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				dispatch({
					type: FETCH_AL_SMELTER_PRODUCTION,
					payload: {
						[collapse]:
							response.combinedIdx || response.singleIdx[0]?.data || []
					}
				});
			},
			(err) =>
				dispatch({
					type: FETCH_AL_SMELTER_PRODUCTION_ERR,
					payload: err
				})
		);
	};
export const resetAlSmelterProduction = () => (dispatch) =>
	dispatch({ type: RESET_AL_SMELTER_PRODUCTION });

export const fetchAlMtdProduction =
	({ grouping, id = '', ute = '' }) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.alMtdProduction, {
				grouping,
				id,
				ute
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				dispatch({
					type: FETCH_AL_MTD_PRODUCTION,
					payload: response
				});
			},
			(err) =>
				dispatch({
					type: FETCH_AL_MTD_PRODUCTION_ERR,
					payload: err
				})
		);
	};

export const resetAlMtdProduction = () => ({
	type: FETCH_AL_MTD_PRODUCTION,
	payload: []
});

export const fetchAlProductionBySmelter =
	({ ids, collapse, ute = '', startDate = '', endDate = '' }) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.alProductionBySmelters, {
				ids,
				collapse,
				ute,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) =>
				dispatch({
					type: FETCH_AL_PRODUCTION_BY_SMELTER,
					payload: response
				}),
			(err) =>
				dispatch({
					type: FETCH_AL_PRODUCTION_BY_SMELTER_ERR,
					payload: err
				})
		);
	};

export const resetAlProductionBySmelter = () => ({
	type: RESET_AL_PRODUCTION_BY_SMELTER,
	payload: {}
});

export const selectAlProdSmelter = (key) => ({
	type: SELECT_AL_PROD_SMELTER,
	payload: key
});

export const unselectAlProdSmelter = (key) => ({
	type: UNSELECT_AL_PROD_SMELTER,
	payload: key
});

export const resetAlProdSmelters = () => ({
	type: RESET_AL_PROD_SMELTERS
});
